import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { ComponentType } from 'react';
import { CheckoutStore } from '~/mobx/checkoutStore';

interface CheckoutStoreContextType {
  store: CheckoutStore;
}

export const CheckoutStoreContext = React.createContext<null | CheckoutStoreContextType>(null);

export const useCheckoutStoreContext = () => {
  const context = React.useContext(CheckoutStoreContext);
  return context as CheckoutStoreContextType;
};

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export type TWithStoreHOC = <P extends unknown>(Component: ComponentType<P>) => (props: P) => JSX.Element;

export const withCheckoutStore: TWithStoreHOC = (WrappedComponent) =>
  function (props) {
    const ComponentWithStore = () => {
      const { store } = useCheckoutStoreContext();

      // @ts-ignore
      return <WrappedComponent {...props} checkoutStore={store} />;
    };

    ComponentWithStore.defaultProps = { ...WrappedComponent.defaultProps };
    ComponentWithStore.displayName = `WithStores(${WrappedComponent.name || WrappedComponent.displayName})`;

    hoistNonReactStatics(ComponentWithStore, WrappedComponent);

    return <ComponentWithStore />;
  };
